
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ai/document-collection-filing",
      function () {
        return require("private-next-pages/en/ai/document-collection-filing/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/ai/document-collection-filing"])
      });
    }
  